import { Controller } from 'stimulus'

export default class extends Controller
  initialize: ->
    Rails.fire @element, 'submit'